import { createReadStream } from "fs";
import http from "./http-common";
import { renameNestedObject } from "./utils";

export const searchQuery = async (query: string) => {
  const apiUrl = "/EASAS/rest/datasets/search";
  const searchCount = 100;
  const url: string = apiUrl + "?query=" + query + "&limit=" + searchCount;

  const res: any = http
    .get(url)
    .then((res) => {
      const results = res.data.map((d: { title: any; identifier: any; unit: any; groupTitle: any }) => {
        return formatResults(d);
      });
      return results;
    })
    .catch((err) => {
      _handleError(err);
      return null;
    });
  return res.then((r: any) => {
    return r;
  });
};

export const getAllDatasets = async () => {
  const url = "/EASAS/rest/datasets/search";
  const res: any = http
    .get(url)
    .then((res) => {
      const results = res.data.map((d: { title: any; identifier: any; unit: any; groupTitle: any }) => {
        return formatResults(d);
      });
      return results;
    })
    .catch((err) => {
      _handleError(err);
      return null;
    });
  return res;
};

export const getAllGroups = async () => {
  const url = "/EASAS/rest/datasets/groups";
  const res: any = http
    .get(url)
    .then((res) => {
      // const results = res.data.map((d: { title: any; identifier: any; unit: any; groupTitle: any }) => {
      // return formatResults(d);
      //});
      const results = renameNestedObject(res.data); //res.data.map((r:any) => {return {key: r.id, label: r.title, children: r.children}})
      return results;
    })
    .catch((err) => {
      _handleError(err);
      return null;
    });
  return res;
};

export const formatResults = (res: any): any => {
  if (res !== undefined) {
    let title: string = "";
    let group: string = "";
    let unit: string = "";
    let formatedSearchString: string = "";
    if (res.title !== undefined && res.title !== "") {
      title = res.title;
    }
    if (res.groupTitle !== undefined && res.groupTitle !== "") {
      group = " | " + res.groupTitle;
    }
    if (res.unit !== undefined && res.unit !== "") {
      unit = " | " + res.unit;
    }
    formatedSearchString = [title, group, unit].join("");

    const formatedSearchResults = {
      formatedString: formatedSearchString,
      title: res.title,
      unit: res.unit,
      group: res.groupTitle,
      id: res.identifier,
    };
    return formatedSearchResults;
  } else return "";
};

function _handleError(error: any) {
  console.log("Error while Fetching data from server, error:" + error.message);
}

export const searchSingleDatasetQuery = async (query: string) => {
  const apiUrl = "/EASAS/rest/datasets/search";
  const searchCount = 10;
  const url: string = apiUrl + "?query=" + query + "&limit=" + searchCount;
  const res: any = http
    .get(url)
    .then((res) => {
      if (res !== undefined && res !== null && res.data.length === 1) {
        if (query === res.data[0].title) {
          const formatedResults = formatResults(res.data[0]);
          return formatedResults;
        }
      } else return "";
    })
    .catch((err) => {
      _handleError(err);
      return "";
    });
  return res.then((r: any) => {
    return r;
  });
};
